import ActionPanel from '../components/ActionPanel.jsx';
import { ExternalLinkIcon } from '../components/icons.jsx';
import ScreenHeader from '../components/ScreenHeader.jsx';
import { HELP_PATH } from '../navigation/paths.js';

// The Videos section — the app's Menu/VideoTutorials.js as a web page: the same
// three links to the Ideal Heating YouTube playlist, opened in a new tab. The app
// keeps these URLs inline in its screen rather than exporting them, so they are
// restated here and are the one thing to keep in step with it.
const videos = [
  {
    title: 'Halo and Alexa',
    href: 'https://www.youtube.com/watch?v=7anUe9rQ_Rc&list=PLlmsu_iFuOZs47IYbDfwK4aN_C3ZDW2mr&index=10',
  },
  {
    title: 'Halo and Google Home',
    href: 'https://www.youtube.com/watch?v=oQsLAPZic1w&list=PLlmsu_iFuOZs47IYbDfwK4aN_C3ZDW2mr&index=14',
  },
  {
    title: 'Geolocation',
    href: 'https://www.youtube.com/watch?v=_QgifEC8T1Q&list=PLlmsu_iFuOZs47IYbDfwK4aN_C3ZDW2mr&index=15',
  },
];

export default function VideosScreen() {
  return (
    <main className="app-shell screen">
      <ScreenHeader
        title="Video Tutorials"
        sub="The following links will take you to the Ideal Heating YouTube web page"
        backTo={HELP_PATH}
        backLabel="Help"
      />
      <nav className="action-panel-list" aria-label="Video tutorials">
        {videos.map(({ title, href }) => (
          <ActionPanel
            key={href}
            href={href}
            title={title}
            actionIcon={<ExternalLinkIcon />}
          />
        ))}
      </nav>
    </main>
  );
}
